import { searchForGifs } from "../http/search";
import { State, CHANGE_ZOOM_LEVEL, CHANGE_RATING, FOCUS_GIF } from "./types";

/* Not ideal that I introduced this side effect of storing the previousController
   and aborting if the previous controller exists. Doing this to the case where
   a previous request is resolved after the most recent request. Would be good to
   find a more "redux way" of doing this with middleware. */
let previousController: AbortController | null = null;
export function performSearch(searchTerm: string) {
  const thunk = (dispatch, getState) => {
    if (previousController) {
      previousController.abort();
    }
    previousController = new AbortController();

    const state = getState();
    return searchForGifs({
      searchTerm,
      rating: state.rating,
      abortController: previousController,
    }).then(
      ({ data, pagination }) => {
        previousController = null;
        dispatch({
          type: "PERFORM_SEARCH",
          searchTerm,
          results: { data, pagination },
        });
      },
      (e) => {
        if (e.name === "AbortError") return;
        dispatch({
          type: "SEARCH_FAILED",
          error: "Something went wrong with the search, please try again.",
        });
      }
    );
  };

  thunk.meta = {
    debounce: {
      time: 600,
      key: "PERFORM_SEARCH",
    },
  };

  return thunk;
}

export function loadMore() {
  return async (dispatch, getState) => {
    const state = getState();
    const { data, pagination } = await searchForGifs({
      searchTerm: state.searchTerm,
      rating: state.rating,
      offset: state.pagination.currentCount,
    });
    dispatch({ type: "LOAD_MORE", results: { data, pagination } });
  };
}

export function changeZoomLevel(size: State["zoomLevel"]): CHANGE_ZOOM_LEVEL {
  return {
    type: "CHANGE_ZOOM_LEVEL",
    size: size,
  };
}

export function changeRating(rating: State["rating"]): CHANGE_RATING {
  // TODO do search request when changing rating?
  return {
    type: "CHANGE_RATING",
    rating: rating,
  };
}

export function focusGif(gifId: State["focusedGifId"]): FOCUS_GIF {
  return {
    type: "FOCUS_GIF",
    gifId,
  };
}
